// src/pages/payment-failure.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function PaymentFailure() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-red-50 px-6">
      <div className="bg-white shadow-lg rounded-xl p-10 max-w-md text-center">
        <h1 className="text-3xl font-bold text-red-600 mb-4">Payment Failed ❌</h1>
        <p className="text-gray-700 mb-6">
          Something went wrong with the payment. Please try again or use a different payment method.
        </p>
        <Link
          to="/pricing"
          className="inline-block px-6 py-3 bg-red-600 text-white font-semibold rounded-md hover:bg-red-700 transition"
        >
          Back to Pricing
        </Link>
      </div>
    </main>
  );
}
